export default function Logo({ small = false, variant = "auto", showText = true }) {
    // variant: "auto" (default light bg), "light" (for dark bg), "blue-bg" (for solid brand blue bg)
    const size = small ? 32 : 44;
    const textDark = variant === "light" || variant === "blue-bg" ? "text-white" : "text-zinc-950";
    const accentDark = variant === "blue-bg" ? "text-white" : "text-fzblue";
    return (
        <div className="flex items-center gap-2 select-none" data-testid="brand-logo">
            <div
                className="shrink-0 overflow-hidden"
                style={{
                    width: size,
                    height: size,
                    borderRadius: 10,
                    background: variant === "light" || variant === "blue-bg" ? "#ffffff" : "transparent",
                    padding: variant === "light" || variant === "blue-bg" ? 2 : 0,
                    boxShadow: variant === "auto" ? "0 0 0 1px rgba(0,0,0,0.06)" : undefined,
                }}
            >
                <img
                    src="/brand/logo.jpg"
                    alt="FrigoZero logo"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: "center 62%", transform: "scale(1.55)" }}
                    draggable={false}
                />
            </div>
            {showText && (
                <div className={"font-display font-black tracking-tighter " + (small ? "text-lg" : "text-xl")}>
                    <span className={textDark}>FRIGO</span>
                    <span className={accentDark}>ZERO</span>
                    <span className={accentDark}>.</span>
                </div>
            )}
        </div>
    );
}
